import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { LoggedInUserSchema } from '../../_offline/models/logged-in-user.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LoggedInUserDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<LoggedInUserSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.LOGGED_IN_USER.GET_ALL);
  }

  getCurrentUser(): Observable<LoggedInUserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.LOGGED_IN_USER.GET_CURRENT_USER);
  }

  get(userId: string): Observable<LoggedInUserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.LOGGED_IN_USER.GET, userId);
  }

  put(loggedInUser: LoggedInUserSchema): Observable<LoggedInUserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.LOGGED_IN_USER.PUT, loggedInUser);
  }

  public putIsAgreedTerms(userId: string, isAgreedTerms: boolean): Observable<LoggedInUserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.LOGGED_IN_USER.PUT_IS_AGREED_TERMS, userId, isAgreedTerms);
  }

  delete(userId: string): Observable<LoggedInUserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.LOGGED_IN_USER.DELETE, userId);
  }
}
